/**
 * Loads the emoji-picker chunk (ngx-emoji-mart + its emoji data + CSS) at most once per app
 * session. The promise is cached at module scope rather than per component, so every consumer -
 * the rich text editor and the plain input chips - shares a single download; the browser then keeps
 * that content-hashed chunk cached until the next deploy changes it.
 */
let emojiPickerComponentPromise: Promise<typeof import('./emoji-picker-lazy.component')> | undefined;

export function loadEmojiPickerComponent() {
  if (!emojiPickerComponentPromise) {
    emojiPickerComponentPromise = import(/* webpackChunkName: "emoji-picker" */ './emoji-picker-lazy.component');
  }

  return emojiPickerComponentPromise;
}
